import { useQuery } from "@tanstack/react-query";
import { getValidatedClientDeals } from "@/api";
import { Deal } from "@/types";

export const useValidatedClientDeals = (clientId: number | null) => {
  const query = useQuery<Deal[]>({
    queryKey: ["validatedClientDeals", clientId],
    queryFn: () => getValidatedClientDeals(clientId!),
    enabled: !!clientId,
  });

  return {
    ...query,
    data: query.data || [],
  }
};
